import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "__cmp_overlay" }, null, -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayerOne = _resolveComponent("LayerOne")!
  const _component_LayerTwo = _resolveComponent("LayerTwo")!
  const _component_LayerThree = _resolveComponent("LayerThree")!
  const _component_LayerNoConsent = _resolveComponent("LayerNoConsent")!
  const _component_LayerStateColorado = _resolveComponent("LayerStateColorado")!
  const _component_LayerStateCalifornia = _resolveComponent("LayerStateCalifornia")!
  const _component_LayerStateConnecticut = _resolveComponent("LayerStateConnecticut")!
  const _component_LayerStateUtah = _resolveComponent("LayerStateUtah")!
  const _component_LayerStateVirginia = _resolveComponent("LayerStateVirginia")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          id: "__cmp_body",
          style: _normalizeStyle(_ctx.styleObject)
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerOne')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LayerOne, {
                      onChangeViewEvent: _ctx.handleChangeView,
                      onStoreTCStringEvent: _ctx.handleStoreTCString,
                      onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                      onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                    }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerTwo')
                ? (_openBlock(), _createBlock(_component_LayerTwo, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerThree')
                ? (_openBlock(), _createBlock(_component_LayerThree, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerNoConsent')
                ? (_openBlock(), _createBlock(_component_LayerNoConsent, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    onStoreTCStringEvent: _ctx.handleStoreTCString,
                    onStoreAcceptAllTCStringEvent: _ctx.handleStoreAcceptAllTCStringEvent,
                    onStoreRejectAllTCStringEvent: _ctx.handleStoreRejectAllTCString
                  }, null, 8, ["onChangeViewEvent", "onStoreTCStringEvent", "onStoreAcceptAllTCStringEvent", "onStoreRejectAllTCStringEvent"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateColorado')
                ? (_openBlock(), _createBlock(_component_LayerStateColorado, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateCalifornia')
                ? (_openBlock(), _createBlock(_component_LayerStateCalifornia, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateConnecticut')
                ? (_openBlock(), _createBlock(_component_LayerStateConnecticut, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateUtah')
                ? (_openBlock(), _createBlock(_component_LayerStateUtah, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.view=='layerStateVirginia')
                ? (_openBlock(), _createBlock(_component_LayerStateVirginia, {
                    key: 0,
                    onChangeViewEvent: _ctx.handleChangeView,
                    cmpApi: _ctx.cmpApi
                  }, null, 8, ["onChangeViewEvent", "cmpApi"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 4)
      ]))
    : _createCommentVNode("", true)
}